import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
    Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { GeneralInsurerForm } from "./components/generalInsurerForm";
import { fetchDataById, putData } from "../../../services";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";

const EditGeneralInsurer = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const params = useParams();
  const paramId = params.id;

  const [insurerData, setInsurerData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
    
        if (paramId) {
          setCircleLoading(true);
          try{
            await fetchDataById(`/reference/general/insurer-master/${paramId}`).then((res) => {
              
              const responseData = res?.data;
              setInsurerData({
                companyName: responseData?.companyName,
                companyCode: responseData?.companyCode,
                companyType: {label: responseData?.companyType, value: responseData?.companyType},
                websiteUrl: responseData?.websiteUrl,
                sortOrder: responseData?.sortOrder,
                active: responseData?.isActive,

                companyNameStatus: responseData?.companyName ? "success" : "unchecked",
                companyCodeStatus: responseData?.companyCode ? "success" : "unchecked",
                companyTypeStatus: responseData?.companyType ? "success" : "unchecked",
                websiteUrlStatus: responseData?.websiteUrl ? "success" : "unchecked",
                sortOrderStatus: responseData?.sortOrder !== null ? "success" : "unchecked",
              })
            });
          }
          catch(error){
            console.error("Error fetching data",error)
            showSnackbar(error?.response?.data?.message, "error");
          }
          finally{
            setCircleLoading(false)
          }
        }

      };
  
    fetchData();
  }, [params.id]);
  
  const handleUpdateInsurer = async (insurerData) => {
    
    const payload = {
      companyName: insurerData?.companyName,
      companyCode: insurerData?.companyCode,
      companyType: insurerData?.companyType?.value,
      websiteUrl: insurerData?.websiteUrl,
      sortOrder: Number(insurerData?.sortOrder),
      isActive: insurerData?.active,
    };
    try {
      const response = await putData(`/reference/general/insurer-master/${paramId}`, payload);
      if(response?.success){
        navigate("/general-master/general-insurer");
        showSnackbar(response?.message || "Successfully updated","success");
      }
      else{
        showSnackbar(response?.message,"error");
      }
    } catch (error) {
      console.error("Error fetching data",error)
      showSnackbar(error?.response?.data?.message, "error");
    }
    finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-insurer")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Insurer details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Insurer details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralInsurerForm onsubmit={handleUpdateInsurer} editInsurerData={insurerData} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditGeneralInsurer;
